import { __assign, __extends, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import throttle from 'lodash/throttle';
import { withMobileContext } from '../../Context/MobileContext';
import PopperManager from '../PopperManager';
import Popper from '../Popper';
import s from './PopoverOnHover.scss';
var SCROLL_THROTTLE_TIMEOUT = 400;
var PopoverOnHover = /** @class */ (function (_super) {
    __extends(PopoverOnHover, _super);
    function PopoverOnHover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isVisible: false,
        };
        _this.isMountedNow = false;
        _this.attachScrollListener = function () {
            window.addEventListener('wheel', _this.hidePopoverDebounced);
        };
        _this.detachScrollListener = function () {
            window.removeEventListener('wheel', _this.hidePopoverDebounced);
        };
        _this.showPopover = function () {
            if (!_this.isMountedNow) {
                return;
            }
            _this.props.hideOnScroll && _this.attachScrollListener();
            if (!_this.state.isVisible) {
                _this.setState({ isVisible: true }, _this.props.onVisible);
            }
        };
        _this.hidePopover = function () {
            if (!_this.isMountedNow) {
                return;
            }
            _this.hoverTimerId && clearTimeout(_this.hoverTimerId);
            _this.props.hideOnScroll && _this.detachScrollListener();
            if (_this.state.isVisible) {
                _this.setState({ isVisible: false }, _this.props.onHidden);
            }
        };
        _this.onTouchEnd = function () {
            if (!_this.props.showOnMobileClick) {
                return;
            }
            if (!_this.isMountedNow) {
                return;
            }
            if (_this.state.isVisible) {
                _this.hidePopover();
            }
            else {
                _this.showPopover();
            }
        };
        _this.onMouseEnter = function () {
            if (_this.props.isMobile) {
                return;
            }
            var _a = _this.props.hoverDelay, hoverDelay = _a === void 0 ? 1 : _a;
            _this.hideTimerId && clearTimeout(_this.hideTimerId);
            _this.hoverTimerId = window.setTimeout(_this.showPopover, hoverDelay);
        };
        _this.onMouseLeave = function () {
            if (_this.props.isMobile) {
                return;
            }
            // a small delay on hiding is needed to handle both tooltip and reneference hovers
            _this.hideTimerId = window.setTimeout(_this.hidePopover, 100);
        };
        _this.hidePopoverDebounced = throttle(_this.hidePopover, SCROLL_THROTTLE_TIMEOUT, {
            leading: true,
        });
        return _this;
    }
    PopoverOnHover.prototype.componentDidMount = function () {
        this.isMountedNow = true;
    };
    PopoverOnHover.prototype.componentWillUnmount = function () {
        this.isMountedNow = false;
    };
    PopoverOnHover.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, children = _a.children, renderReference = _a.renderReference;
        var isVisible = this.state.isVisible;
        return (React.createElement(PopperManager, { renderReference: function (_a) {
                var ref = _a.ref;
                return (React.createElement("span", { ref: (!renderReference && ref) || undefined, className: classnames(s['children-wrapper'], className), onTouchEnd: _this.onTouchEnd, onMouseEnter: _this.onMouseEnter, onMouseLeave: _this.onMouseLeave }, renderReference ? renderReference({ ref: ref }) : children));
            } }, isVisible && this.renderPopper()));
    };
    PopoverOnHover.prototype.renderPopper = function () {
        var _a = this.props, className = _a.className, contentClassName = _a.contentClassName, popoverContent = _a.popoverContent, children = _a.children, hoverDelay = _a.hoverDelay, _b = _a.usePortal, usePortal = _b === void 0 ? true : _b, _c = _a.modifiers, modifiers = _c === void 0 ? {} : _c, 
        // Design indicates popovers should be separated 8px away from their reference point.
        // Since most icon boxes and/or text have some amount of blank space around them, setting
        // the default popover offset to 6px seems to achieve a look pretty close to spec in general.
        // In other cases it can be overriden if it really needs fixing.
        _d = _a.popoverOffset, 
        // Design indicates popovers should be separated 8px away from their reference point.
        // Since most icon boxes and/or text have some amount of blank space around them, setting
        // the default popover offset to 6px seems to achieve a look pretty close to spec in general.
        // In other cases it can be overriden if it really needs fixing.
        popoverOffset = _d === void 0 ? '0, 6' : _d, popperProps = __rest(_a, ["className", "contentClassName", "popoverContent", "children", "hoverDelay", "usePortal", "modifiers", "popoverOffset"]);
        var isVisible = this.state.isVisible;
        var offset = (popoverOffset && { offset: popoverOffset }) || undefined;
        var mergedModifiers = __assign({ preventOverflow: { boundariesElement: 'window' }, offset: offset }, modifiers);
        return (React.createElement(Popper, __assign({}, popperProps, { eventsEnabled: isVisible, className: classnames(s['root'], isVisible && s['visible']), contentClassName: contentClassName, onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, modifiers: mergedModifiers, usePortal: usePortal }), popoverContent));
    };
    PopoverOnHover.defaultProps = {
        hideOnScroll: true,
        showOnMobileClick: false,
    };
    return PopoverOnHover;
}(React.Component));
export { PopoverOnHover };
export default withMobileContext(PopoverOnHover);
//# sourceMappingURL=PopoverOnHover.js.map